import { normalizeExternalProfileUrl } from "../../utils/externalProfileUrl";

function normalizeSteamIdCandidate(value) {
  if (typeof value === "number" && Number.isFinite(value)) {
    return String(Math.trunc(value));
  }

  if (typeof value !== "string") {
    return null;
  }

  const trimmedValue = value.trim();
  if (!trimmedValue || !/^\d+$/.test(trimmedValue)) {
    return null;
  }

  return trimmedValue;
}

export function buildProfileExternalLinks(profileData) {
  const steamProfileUrl = normalizeExternalProfileUrl(
    profileData?.steamProfileUrl
  );
  const steamId =
    normalizeSteamIdCandidate(profileData?.steamId64) ||
    normalizeSteamIdCandidate(profileData?.steam64Id) ||
    normalizeSteamIdCandidate(profileData?.steamId);

  return {
    steamProfileUrl:
      steamProfileUrl ||
      (steamId ? `https://steamcommunity.com/profiles/${steamId}` : null),
    faceitProfileUrl: normalizeExternalProfileUrl(
      profileData?.faceitProfileUrl
    ),
  };
}
